import {Controller} from "@hotwired/stimulus"

export class CallDurationController extends Controller {
  static values = {connectedAt: String}

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const start = Date.parse(this.connectedAtValue)
    if (isNaN(start)) {
      this.element.textContent = "–"
      return
    }
    const seconds = Math.max(0, Math.floor((Date.now() - start) / 1000))
    const mm = String(Math.floor(seconds / 60)).padStart(2, "0")
    const ss = String(seconds % 60).padStart(2, "0")
    this.element.textContent = `${mm}:${ss}`
  }
}
